import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCCFPointsAPI } from "../../apiConfig/apiCall";

export const getCCFPoints = createAsyncThunk('getCCFPoints', async () => {
    const response = await getCCFPointsAPI();
    return response.data;
});